export default function PaymentSchedule() {
  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold mb-4">Payment Schedule</h1>
      <p className="text-gray-600">Payment schedule coming soon...</p>
    </div>
  );
}

